/* eslint-disable */
import axios, { AxiosRequestConfig, Method } from "axios";

// var axios = (<any>window).axios;
//axios.defaults.headers["withCredentials"] = true;
//axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.post["Content-Type"] = "application/json";
//请求拦截
axios.interceptors.request.use(
  function(config: any) {
    if (config.loading === undefined || config.loading) {
      config.loading = "loading";
      // console.log("loading...")
    }
    return config;
  },
  function(error: any) {
    if (error.config.loading) {
      // console.log("loading end...")
    }
    return Promise.reject(error);
  }
);
//响应拦截
axios.interceptors.response.use(
  function(response: any) {
    if (response.config.loading) {
      // console.log("loading end...")
    }
    return response;
  },
  function(error: any) {
    if (error.config.loading) {
      // console.log("loading end...")
    }
    return Promise.reject(error);
  }
);

export default {
  ajax<T>(url: string, data: any, method?: Method, options?: AxiosRequestConfig): Promise<T> {
    if (options === undefined) options = {};
    options.url = url;
    options.data = data;
    // options.method=
    options.method = method;
    // options.withCredentials = true;
    let SfsSes = sessionStorage && sessionStorage.getItem("SfsSes");
    if (SfsSes != undefined) {
      options.headers = options.headers || {};
      options.headers.SfsSes = SfsSes;
    }
    return axios(options)
      .catch(function(error: any) {
        // if (options.failTips == undefined || options.failTips) {
        //   console.log(error.message);
        // } else {
        //   console.log(error);
        // }
        error.data = {
          result: error.response,
          code: "",
          message: error.message,
          status: "",
          isSuccess: false,
        };
        return error;
      })
      .then(function(json: any) {
        return json.data;
      });
  },
  get<T>(url: string, options?: any): Promise<T> {
    return this.ajax<T>(url, "", "get", options);
  },
  post<T>(url: string, data: any, options?: any): Promise<T> {
    for (const d in data) {
      if (data[d] instanceof Date) {
        data[d] = (<any>window).moment(data[d]).format("YYYY-MM-DD HH:mm:ss");
      }
    }
    return this.ajax(url, JSON.stringify(data), "post", options);
  },
};
